'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.imageLazyLoader', []);

_module.directive('imageLazyLoaderV1', imageLazyLoader);

exports.default = _module;


function imageLazyLoader() {
    return {
        restrict: 'A',
        scope: true,
        controller: ['$scope', '$element', '$attrs', function controller($scope, $element, $attrs) {
            var vm = this;

            var images = $element[0].querySelectorAll('source, img');

            var config = {
                // If the image gets within 50px in the Y axis, start the download.
                rootMargin: '0px 0px',
                threshold: 0.01
            };

            var observer = void 0;

            function preloadImage(entry) {

                if (_angular2.default.element(entry).attr('data-src')) {
                    entry.src = _angular2.default.element(entry).attr('data-src');
                }
                if (_angular2.default.element(entry).attr('data-srcset')) {
                    entry.srcset = _angular2.default.element(entry).attr('data-srcset');
                }
            }

            function onIntersection(entries) {
                // Loop through the entries
                entries.forEach(function (entry) {
                    // Are we in viewport?
                    if (entry.intersectionRatio > 0) {

                        // Stop watching and load the image
                        observer.unobserve(entry.target);
                        preloadImage(entry.target);
                    }
                });
            }

            // If we don't have support for intersection observer, load the images immediately
            if (!('IntersectionObserver' in window)) {
                (0, _from2.default)(images).forEach(function (image) {
                    return preloadImage(image);
                });
            } else {
                // It is supported, load the images
                observer = new IntersectionObserver(onIntersection, config);

                images.forEach(function (image) {
                    observer.observe(image);
                });
            }
        }]
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/imageLazyLoader/imageLazyLoader.directive.js
// module id = 807
// module chunks = 0